import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { useEffect as b, memo as x, useCallback as O, useMemo as S } from "react";
import { Select as s } from "antd";
import { u as F } from "../styled-components.browser.esm-3eb04950.js";
import "../useResizeDetector-1ae5f4fb.js";
const h = (t, o, n) => {
  b(
    () => {
      o !== n && n && (t == null || t(n));
    },
    [t, o, n]
  );
}, p = (t, o, n) => /* @__PURE__ */ u(
  s.Option,
  {
    value: t.value,
    label: /* @__PURE__ */ d(v, { children: [
      n,
      t.label
    ] }),
    children: t.label
  },
  `${o}-${t.value}`
), v = F.div`
  display: flex;
  align-items: center;
  gap: 8px;
`, j = ({
  value: t,
  options: o,
  onChange: n,
  labelIcon: c,
  ...l
}) => {
  const a = O(
    (e) => o.find(
      (r) => {
        var i;
        return ((i = r.options) == null ? void 0 : i.find((f) => e(f))) ?? e(r);
      }
    ),
    [o]
  ), m = S(
    () => {
      var e;
      return t && !a((i) => i.value === t) ? (e = a(() => !0)) == null ? void 0 : e.value : t;
    },
    [t, a]
  );
  return h(n, t, m), /* @__PURE__ */ u(s, { optionFilterProp: "children", ...l, value: m, onChange: n, virtual: !1, optionLabelProp: "label", children: o.map(
    (e) => {
      var r;
      return e.options ? /* @__PURE__ */ u(s.OptGroup, { label: e.label, children: e.options.map((i) => p(i, l.name, c)) }, typeof e.label == "string" ? e.label : (r = e.value) == null ? void 0 : r.toString()) : p(e, l.name, c);
    }
  ) });
}, B = x(j);
export {
  B as default
};
//# sourceMappingURL=SimpleSelect.js.map
